import React from 'react';
export default (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    fill="none"
    height="24"
    width="24"
    aria-hidden="true"
    focusable="false"
    viewBox="0 0 24 24"
    style={{ verticalAlign: 'middle' }}
  >
    <path d="M3 18h18v-2H3v2zm0-5h18v-2H3v2zm0-7v2h18V6H3z" fill="#000" />
  </svg>
);
